import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./AppointmentJoin.css";

const AppointmentJoin = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token         = searchParams.get("token");
    const roomId        = searchParams.get("roomId");
    const userId        = searchParams.get("userId");
    const userType      = searchParams.get("userType")      || "patient";
    const slotStartTime = searchParams.get("slotStartTime");
    const slotEndTime   = searchParams.get("slotEndTime");
    const authToken     = searchParams.get("authToken");       // ← Spring Boot JWT
    const appointmentId = searchParams.get("appointmentId");   // ← appointment ID

    if (!roomId || !userId) {
      console.error("❌ Missing required parameters: roomId or userId");
      alert("Invalid link. Missing roomId or userId.");
      navigate("/");
      return;
    }

    if (!token || token.length < 10) {
      console.error("❌ Missing or invalid token");
      alert("Invalid or missing token. Please use the link provided.");
      navigate("/");
      return;
    }

    // ── Persist everything to sessionStorage ──────────────────────────────────
    sessionStorage.setItem("video_token", token);
    if (slotStartTime)  sessionStorage.setItem("slot_start_time",  slotStartTime);
    if (slotEndTime)    sessionStorage.setItem("slot_end_time",    slotEndTime);
    if (authToken)      sessionStorage.setItem("auth_token",       authToken);
    if (appointmentId)  sessionStorage.setItem("appointment_id",   appointmentId);
    sessionStorage.setItem("room_id",   roomId);
    sessionStorage.setItem("user_id",   userId);
    sessionStorage.setItem("user_type", userType);

    // ── Build Room URL — authToken is intentionally NOT forwarded in the URL
    //    (prevents it appearing in browser history / server logs).
    //    Room.jsx reads it from sessionStorage instead.
    const queryParams = new URLSearchParams({ userId, userType, roomId, token });
    if (slotStartTime)  queryParams.set("slotStartTime",  slotStartTime);
    if (slotEndTime)    queryParams.set("slotEndTime",    slotEndTime);
    if (appointmentId)  queryParams.set("appointmentId",  appointmentId);

    console.log("✅ AppointmentJoin: redirecting to room", roomId);
    navigate(`/room/${roomId}?${queryParams.toString()}`, { replace: true });

  }, [searchParams, navigate]);

  return (
    <div className="appointment-join-container">
      <div className="loading-content">
        <div className="spinner"></div>
        <h2>Joining Appointment</h2>
        <p>Please wait while we connect you to the video call...</p>
        <div className="loading-details">
          <div className="detail-item">
            <span className="label">Room ID:</span>
            <span className="value">{searchParams.get("roomId") || "Loading..."}</span>
          </div>
          <div className="detail-item">
            <span className="label">User:</span>
            <span className="value">
              {searchParams.get("userType") === "doctor" ? "Doctor" : "Patient"}
            </span>
          </div>
          {searchParams.get("slotStartTime") && (
            <div className="detail-item">
              <span className="label">Appointment:</span>
              <span className="value">
                {new Date(searchParams.get("slotStartTime")).toLocaleTimeString([], {
                  hour: "2-digit", minute: "2-digit",
                })}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AppointmentJoin;
